import { render } from "./sectors-tab.vue?vue&type=template&id=359a6669&scoped=true"
import script from "./sectors-tab.vue?vue&type=script&lang=js"
export * from "./sectors-tab.vue?vue&type=script&lang=js"

import "./sectors-tab.vue?vue&type=style&index=0&id=359a6669&lang=scss&scoped=true"

import exportComponent from "/home/rof/src/bitbucket.org/AsokoInsight/virtual-dealroom/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-359a6669"]])

export default __exports__